import React from 'react';
import styled from 'styled-components';
import { PlayIcon } from '../Icon';
import { UnstyledButton } from './Button';
import { OnClickFocusWrapper } from '../UtilityWrappers';
const ContainerButton = styled(UnstyledButton) `
  display: flex;
  align-items: center;
  margin-left: -10px;
  padding: 10px;

  &:hover,
  &:focus {
    span {
      text-decoration: underline;
    }
    path {
      fill: ${({ theme }) => theme.primaryRed};
    }
  }

  &:active {
    circle:first-of-type {
      fill-opacity: 1;
    }

    path {
      fill: ${({ theme }) => theme.primaryBlack};
    }
  }
`;
const Text = styled.span `
  font-family: ${({ theme }) => theme.fontFamilyHeading};
  color: ${({ theme, asWhite }) => (asWhite ? theme.primaryWhite : theme.primaryBlack)};
  font-size: 16px;
  margin-left: 8px;
`;
export const PlayButton = ({ textField, onClick, asWhite, size, isNotTabbable, }) => {
    const text = textField && textField.value;
    return (React.createElement(OnClickFocusWrapper, null,
        React.createElement(ContainerButton
        // TODO: finalize aria-label approach
        , { "aria-label": !text ? 'Play' : undefined, onClick: onClick, type: "button", tabIndex: isNotTabbable ? -1 : 0 },
            React.createElement(React.Fragment, null,
                React.createElement(PlayIcon, { size: size }),
                text && React.createElement(Text, { asWhite: asWhite }, text)))));
};
